// 🎯 Hook para obtener datos de carrito - Hook for getting cart data
import { useQuery } from '@tanstack/react-query';
import { CartApiAdapter } from '../adapters/CartApiAdapter';
import { createHttpClient } from '@shared/adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';

export const useCartData = (locationId: string | null) => {
  const cartAdapter = new CartApiAdapter(createHttpClient(apiClientWH));

  const {
    data: cartData,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['cartData', locationId],
    queryFn: () => cartAdapter.getCartsByIds(locationId!),
    enabled: !!locationId, // Solo ejecutar si hay locationId
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
  });

  return {
    cartData: cartData?.data?.[0] || null, // Retornar el primer carrito
    isLoading,
    error,
  };
};
